// libs
import styled, { css } from "styled-components";
// hooks
import { useProgressiveImage } from "../lib/hooks/use-progressive-image";
// other
import { fill } from "../styles/utils";
import { ImageObjectFit } from "../models/client";

interface ImageFillProps {
  src: string;
  srcLow?: string;
  alt?: string;
  fit?: ImageObjectFit;
}

const ImageContainer = styled.div<{ fit?: ImageObjectFit; blur?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: filter 1s;

  &::after {
    content: "";
    ${fill()}
    backdrop-filter: blur(2px);
    opacity: ${({ blur }) => (blur ? 1 : 0)};
    transition: opacity 0.6s ease-in;
  }

  img {
    position: absolute;
    object-fit: ${({ fit }) => fit || "cover"};
    pointer-events: none;

    ${({ fit }) =>
      fit === "contain"
        ? css`
            top: 24px;
            left: 24px;
            width: calc(100% - 48px);
            height: calc(100% - 48px);
          `
        : css`
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          `};
  }
`;

export const ImageFill: React.FC<ImageFillProps> = ({
  src,
  srcLow,
  alt,
  fit,
}) => {
  const [progSrc, { blur }] = useProgressiveImage(srcLow || "", src);

  return (
    <ImageContainer fit={fit} blur={srcLow ? blur : false}>
      <img src={srcLow ? progSrc : src} alt={alt} />
    </ImageContainer>
  );
};
